export const MAIN_CONTENT_ID = 'main-content';

// CSS
export const TAB_BOX_SHADOW_WIDTH = '4px';
